import React, { Fragment } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import Attachments from 'components/attachments/components/Attachments';
import useAttachments from 'components/attachments/hooks/useAttachments';

export default function StateWrappedAttachments(props) {
  const {
    currentAttachments,
    handleAttachmentDelete,
    handleAttachmentInsert,
    handleAttachmentUpdate,
    handleAttachmentsReorder,
    handleTmpAttachmentCreate,
    initialCurrentAttachments,
  } = useAttachments({ seedAttachments: props.seedAttachments });

  const initialCurrentAttachmentIds = initialCurrentAttachments.map(
    (attachment) => attachment.id,
  );

  const existingAttachments = currentAttachments.filter(
    (attachment) => !attachment.hashid.startsWith('tmp-'),
  );

  const existingAttachmentsIds = existingAttachments.map(
    (attachment) => attachment.id,
  );

  const attachmentIdsValue = [
    ...new Set([...initialCurrentAttachmentIds, ...existingAttachmentsIds]),
  ];

  const destroyingAttachments = initialCurrentAttachments.reduce(
    (acc, attachment) => {
      if (!existingAttachmentsIds.includes(attachment.id)) {
        acc.push(attachment);
      }

      return acc;
    },
    [],
  );

  let attachmentsindex = 0;

  return (
    <>
      <Attachments
        {...props}
        currentAttachments={currentAttachments}
        onAttachmentDelete={handleAttachmentDelete}
        onAttachmentInsert={handleAttachmentInsert}
        onAttachmentUpdate={handleAttachmentUpdate}
        onAttachmentsReorder={handleAttachmentsReorder}
        onTmpAttachmentCreate={handleTmpAttachmentCreate}
      />
      {props.attachmentIdsField &&
        attachmentIdsValue.map((id) => (
          <HiddenInput
            id={props.attachmentIdsField}
            key={`${props.attachmentIdsField}-${id}`}
            value={id}
          />
        ))}
      {props.attachmentIdsField &&
        existingAttachments.map((attachment) => (
          <input
            key={`attachment-hashid-${attachment.hashid}`}
            name='attachment_hashids[]'
            type='hidden'
            value={attachment.hashid}
          />
        ))}
      {props.attachmentsAttributesField && (
        <>
          {existingAttachments.map((attachment) => {
            const {
              attachedChangedHiddenInputFieldId,
              captionHiddenInputFieldId,
              displaySizeHiddenInputFieldId,
              idHiddenInputFieldId,
              positionHiddenInputFieldId,
            } = buildHiddenInputFieldIds({
              baseField: props.attachmentsAttributesField,
              attributes: [
                'attached_changed',
                'caption',
                'display_size',
                'id',
                'position',
              ],
              index: attachmentsindex,
            });

            attachmentsindex++;

            return (
              <Fragment key={attachment.id}>
                <HiddenInput
                  id={attachedChangedHiddenInputFieldId}
                  value={attachment.hasAttachedChanged ? 1 : 0}
                />
                <HiddenInput
                  id={captionHiddenInputFieldId}
                  value={attachment.caption}
                />
                <HiddenInput
                  id={displaySizeHiddenInputFieldId}
                  value={
                    { 0: 'small', 1: 'medium', 2: 'max' }[
                      attachment.displaySizeValue
                    ]
                  }
                />
                <HiddenInput id={idHiddenInputFieldId} value={attachment.id} />
                <HiddenInput
                  id={positionHiddenInputFieldId}
                  value={attachment.position}
                />
              </Fragment>
            );
          })}
          {destroyingAttachments.map((attachment) => {
            const { destroyHiddenInputFieldId, idHiddenInputFieldId } =
              buildHiddenInputFieldIds({
                baseField: props.attachmentsAttributesField,
                attributes: ['_destroy', 'id'],
                index: attachmentsindex,
              });

            attachmentsindex++;

            return (
              <Fragment key={attachment.id}>
                <HiddenInput id={destroyHiddenInputFieldId} value={1} />
                <HiddenInput id={idHiddenInputFieldId} value={attachment.id} />
              </Fragment>
            );
          })}
        </>
      )}
    </>
  );
}

function buildHiddenInputFieldIds({ attributes, baseField, index }) {
  return attributes.reduce((acc, attribute) => {
    const fieldName = `${_.camelCase(attribute)}HiddenInputFieldId`;

    acc[fieldName] = baseField
      .replace('PLACEHOLDER_INDEX', index)
      .replace('PLACEHOLDER_ATTRIBUTE', attribute);

    return acc;
  }, {});
}

function HiddenInput({ id, value }) {
  return <input id={id} name={id} type='hidden' value={value} />;
}

StateWrappedAttachments.propTypes = {
  seedAttachments: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    included: PropTypes.array,
  }).isRequired,
  attachmentIdsField: PropTypes.string,
  attachmentsAttributesField: PropTypes.string,
};
